var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"fc-event-subtitle",class:_vm.data.class || []},[(_vm.props.calendarIcon)?_c('font-awesome-icon',{staticClass:"flex mr-2",attrs:{"data-cy":"calendar-icon","aria-hidden":"true","icon":['fas', 'calendar-alt']}}):_vm._e(),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }